export const PROJECT_ID_MAX_LENGTH = 128;

export const PROJECT_ID_RULES =
  'Use 1–128 ASCII letters, digits, dots, underscores, or hyphens. Consecutive dots, a single dot, and names that begin and end with double underscores are reserved.';

/**
 * Creates the initial technical identifier suggested by the project-name field.
 *
 * The algorithm decomposes accented Latin characters, removes combining marks,
 * lowercases the result, replaces every run of remaining non-ASCII-alphanumeric
 * characters with one hyphen, trims edge hyphens, and caps the result at the
 * backend's 128-character limit.
 */
export function suggestProjectId(projectName: string): string {
  return projectName
    .normalize('NFKD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
    .slice(0, PROJECT_ID_MAX_LENGTH)
    .replace(/-+$/g, '');
}

/** Mirrors {@code ProjectIdValidator} in the backend. */
export function getProjectIdValidationError(projectId: string): string | null {
  if (!projectId) {
    return 'Project ID is required.';
  }
  if (projectId.length > PROJECT_ID_MAX_LENGTH) {
    return `Project ID must be ${PROJECT_ID_MAX_LENGTH} characters or fewer.`;
  }
  if (!/^[A-Za-z0-9._-]+$/.test(projectId)) {
    return 'Project ID may contain only ASCII letters, digits, dots, underscores, or hyphens.';
  }
  if (projectId === '.' || projectId.includes('..')) {
    return 'A single dot and consecutive dots are reserved.';
  }
  if (projectId.startsWith('__') && projectId.endsWith('__')) {
    return 'Names that begin and end with double underscores are reserved.';
  }
  return null;
}
